import React from 'react';
import { useContext } from '../../Context';

export default function NoData() {
  const { state } = useContext();

  return (
    <div className="mt20">
      {state.resources == null
        ? 'Please, wait ...'
        : 'No matching records found'}
    </div>

  );
}
